<template>
  <fn-form-register
    :errors="errors"
    :button-disabled="buttonDisabled"
    :required-notice="requiredNotice"
    :legal-hidden="legalHidden"
    :full-width-inputs="fullWidthInputs"
    :friends-light="friendsLight"
    :salon="salon"
    @submit="handleSubmit"
  />
</template>

<script>
import newsletter from '@/mixins/Newsletter';

export default defineComponent({
  mixins: [newsletter],
  props: {
    redirectTo: {
      type: String,
      default: '/my-account/',
    },
    buttonDisabled: {
      type: Boolean,
    },
    requiredNotice: {
      type: Boolean,
    },
    legalHidden: {
      type: Boolean,
    },
    redirectDisabled: {
      type: Boolean,
    },
    friendsLight: {
      type: Boolean,
    },
    salon: {
      type: Boolean,
    },
    fullWidthInputs: {
      type: Boolean,
    },
  },
  emits: ['registrationSuccess'],
  data() {
    return {
      errors: null,
      errorMapping: [
        {
          vid: 'user.email',
          name: 'email',
          subject: 'uid',
        },
        {
          vid: 'user.password',
          name: 'password',
          subject: 'password',
        },
      ],
    };
  },
  computed: {
    ...mapWritableState(useMainStore, {
      isLoadingGlobal: 'isLoading',
    }),

    ...mapWritableState(useUserStore, {
      termsOfServiceAccepted: 'termsOfServiceAccepted',
      user: 'user',
    }),
  },
  methods: {
    ...mapActions(useUserStore, {
      create: 'create',
    }),

    async handleSubmit({
      email,
      password,
      loginRecaptchaResponse = null,
      registrationRecaptchaResponse = null,
      newsletterConsent = false,
      legal = false,
      friendsTos = false,
      newsletterRecaptchaResponse = null,
    }) {
      this.isLoadingGlobal = true;
      this.resetErrors();

      try {
        await this.create({
          uid: email.trim(),
          password,
          loginRecaptchaResponse,
          registrationRecaptchaResponse,
          newCustomer: true,
        });

        if (legal) {
          this.termsOfServiceAccepted = true;
        }

        if (friendsTos) {
          this.user.savingsPlan.active = true;
        }

        if (newsletterConsent) {
          await this.registerToNewsletter(newsletterRecaptchaResponse);
        }

        this.registerSuccess();
      } catch (error) {
        this.isLoadingGlobal = false;
        this.registerError(error);
      }
    },
    registerSuccess() {
      this.$emit('registrationSuccess');

      if (this.redirectDisabled) {
        return;
      }

      let filteredQuery = {};
      if (this.$route?.query) {
        filteredQuery = new URLSearchParams({
          ...this.$route.query,
        });

        if (filteredQuery.has('redirectUrl')) {
          filteredQuery.delete('redirectUrl');
        }
      }

      this.$router.push({
        path: this.redirectTo,
        query: {
          newCustomer: true,
          ...filteredQuery,
        },
      });
    },
    registerError(error) {
      let formErrors = this.$errorHandler.getFormErrors(error, this.errorMapping);

      if (formErrors.general && formErrors.general[0] === 'user.creation.failed') {
        formErrors.general[0] = this.$t('userError.creation.failed');
      }

      if (Object.keys(formErrors).length <= 0 || error.response?.status === 401) {
        formErrors = {
          general: [this.$t('forms.register.errors.general')],
        };
      }

      if (error.response?.status === 503) {
        formErrors = {
          general: [this.$t('forms.register.errors.unavailable')],
        };
      }

      this.errors = formErrors;
    },
    resetErrors() {
      this.errors = null;
    },
  },
});
</script>
